import { defineStore } from 'pinia';
import { HttpStatusCode } from 'axios';
import { http } from '@/http';
import { useNotification } from '@kyvg/vue3-notification';
import { useLoading } from 'vue-loading-overlay';
import { useHttpStore } from './http.store';

// const baseUrl = `/APIURL/api/v1`;
const baseUrl = `/api/v1/objects`;
const localUrl = "/objects";
const debug = false;
const loading = useLoading({
    canCancel: false,
    isFullPage: true,
    color: '#f1e7bb',
    loader: 'dots',
    width: 64,
    height: 64,
    backgroundColor: '#000000',
    opacity: 0.3,
    zIndex: 1050,
});
let inited = false;

export const useObjectStore = defineStore('objects',{
    state: () => ({
        items: [],
        selectedObjectId: null,
    }),
    actions: {
        selectObject(id) {
            this.selectedObjectId = id;
        },
        clearSelectedObject() {
            this.selectedObjectId = null;
        },
        async init(forced = false){
            // if (!this.items.length) {
            if (!inited) {
                await this.get()
            }
            inited = this.items.length>0;
            return this.items.length;
        },
        async get (imageWidth = 200) {
            const httpStore = useHttpStore();
            const resp = await httpStore.get(localUrl);
            if (resp) {
                this.items = [].concat(resp);
                this.items.forEach(async o=>{
                    o.picture = await this.getImage(o, imageWidth);
                });
            }    
            return resp;
        },
        async create(objectData) {

            const loader = loading.show();
            try {
                let resp = await http.post(`${baseUrl}`,objectData);
                console.log(`POST ${baseUrl} resp = ${resp.status}`);
                if (resp.status == HttpStatusCode.Ok && resp.data) {
                    return true;
                } else {
                    return false;
                }    
            } catch (err) {
                const { notify } = useNotification()
                notify({
                    title: 'Создание объекта',
                    text: err,
                    type: 'error'    
                });
                console.error(`objectStore.create ${err}`);
                return false;
            } finally {
                loader.hide();
            };
        },
        async update(id, objectData){
            const loader = loading.show();
            try {
                inited = false;
                let resp = await http.patch(`${baseUrl}/${id}`,objectData);
                console.log(`PATCH ${baseUrl}/${id} resp = ${resp.status}`);
                if (resp.status == HttpStatusCode.Ok && resp.data) {
                    const item = this.items.find(o => o.id === id);
                    if (item) Object.assign(item, resp.data);
                    return true;
                } else {
                    return false;
                }
            } catch (err) {
                const { notify } = useNotification()
                notify({
                    title: 'Изменение объекта ',
                    text: err,
                    type: 'error'    
                });
                console.error(`objectStore.update ${err}`);
                return false;
            } finally {
                loader.hide();
            }

        },
        async find(id) {
            let o = null;
            if (this.items.length) {
                o = this.items.find(obj=>{if (obj.id===id) return obj});
                if (o) return o;
            }             
            if (!o) {
                const loader = loading.show();
                try {
                    const resp = await http.get(`${baseUrl}/${id}`);
                    console.log(resp)
                    if (resp.status == HttpStatusCode.Ok && resp.data) {
                        return resp.data;
                    } else {
                        return null;
                    }    
                } catch (err) {
                    const { notify } = useNotification()
                    notify({
                        title: 'Поиск объекта',
                        text: err,
                        type: 'error'    
                    });
                    console.error(`objectStore.find ${err}`);
                    return null;
                } finally {
                    loader.hide();
                }
            }
        },
        async upload(id,image) {
            const httpStore = useHttpStore();
            const res = await httpStore.upload(`${baseUrl}/${id}/image`,image);
            if (res) {
                let o = await this.find(id);
                if (o) {
                    let picture = await this.getImage(o);
                    return picture
                }
                return false
            }
            return false
        },
        async getImage(o,imageWidth=200) {
            try {
                const config = {
                    responseType: 'arraybuffer',
                };
                const resp = await http.get(`${baseUrl}/${o.id}/image?width=${imageWidth}`, config);
                // console.log("image resp=",resp)
                if (resp.status == HttpStatusCode.Ok) {
                    const image = btoa(
                        new Uint8Array(resp.data).reduce((data, byte) => data + 
                        String.fromCharCode(byte), ''));
                    return {image:image, type: resp.headers["content-type"]};
                }
                return null;
            } catch (err) {
                console.warn(`No image for ${o.id}`);
                return null
            }
        },
        async delete(id) {
            const loader = loading.show();
            try {
                const resp = await http.delete(`${baseUrl}/${id}`);
                if (resp.status == HttpStatusCode.Ok || resp.status == HttpStatusCode.NoContent) {
                    this.items = this.items.filter(o => o.id !== id);
                    if (this.selectedObjectId === id) this.selectedObjectId = null;
                    return true;
                }
                return false;
            } catch (err) {
                const { notify } = useNotification();
                notify({ title: 'Удаление объекта', text: err, type: 'error' });
                console.error(`objectStore.delete ${err}`);
                return false;
            } finally {
                loader.hide();
            }
        },
        /**
         *
         * @param {string} id - group id
         */
        async findGroup(id){
            console.log('findGroup ',id)
            const obj = this.items.find(o=>{
                return o.groups.find(g => g.id===id);
            });
            return obj.groups.find(g=>g.id===id);
        },
        /**
         * Create a new group for an object
         * @param {string} objectId - The object ID
         * @param {string} groupName - The name of the new group
         * @param {object} readerType - The reader_type object with sigur or esmart configuration
         * @returns {Promise<boolean>} - True if successful, false otherwise
         */
        async createGroup(objectId, groupName, readerType) {
            const loader = loading.show();
            try {
                const payload = {
                    name: groupName,
                    reader_type: readerType
                };
                const resp = await http.post(`${baseUrl}/${objectId}/groups`, payload);
                console.log(`POST ${baseUrl}/${objectId}/groups resp = ${resp.status}`);
                if (resp.status == HttpStatusCode.Ok || resp.status == HttpStatusCode.Created) {
                const obj = this.items.find(o => o.id === objectId);
                    if (obj && obj.groups) {
                        obj.groups.push(resp.data);
                    }
                    return true;
                } else {
                    return false;
                }
            } catch (err) {
                const { notify } = useNotification();
                notify({
                    title: 'Создание подъезда',
                    text: err.response?.data?.reason || err.message || 'Неизвестная ошибка',
                    type: 'error'
                });
                console.error(`objectStore.createGroup ${err}`);
                return false;
            } finally {
                loader.hide();
            }
        },
        /**
         * Update a group name
         * @param {string} objectId - The object ID
         * @param {string} groupId - The group ID to update
         * @param {string} groupName - The new name for the group
         * @param {object} readerType - The reader_type object with sigur or esmart configuration
         * @param {string} comment - The comment for the group
         * @returns {Promise<boolean>} - True if successful, false otherwise
         */
        async updateGroup(objectId, groupId, groupName, readerType, comment) {
            const loader = loading.show();
            try {
                const payload = {
                    name: groupName,
                    reader_type: readerType,
                    comment: comment
                };
                const resp = await http.patch(`${baseUrl}/${objectId}/groups/${groupId}`, payload);
                console.log(`PATCH ${baseUrl}/${objectId}/groups/${groupId} resp = ${resp.status}`);
                if (resp.status == HttpStatusCode.Ok) {
                    const obj = this.items.find(o => o.id === objectId);
                    if (obj && obj.groups) {
                        const group = obj.groups.find(g => g.id === groupId);
                        if (group) {
                            group.name = groupName;
                            group.reader_type = readerType;
                            group.comment = comment;
                        }
                    }
                    return true;
                } else {
                    return false;
                }
            } catch (err) {
                const { notify } = useNotification();
                notify({
                    title: 'Обновление подъезда',
                    text: err.response?.data?.reason || err.message || 'Неизвестная ошибка',
                    type: 'error'
                });
                console.error(`objectStore.updateGroup ${err}`);
                return false;
            } finally {
                loader.hide();
            }
        },
        /**
         * Delete a group from an object
         * @param {string} objectId - The object ID
         * @param {string} groupId - The group ID to delete
         * @returns {Promise<boolean>} - True if successful, false otherwise
         */
        async deleteGroup(objectId, groupId) {
            const loader = loading.show();
            try {
                const resp = await http.delete(`${baseUrl}/${objectId}/groups/${groupId}`);
                console.log(`DELETE ${baseUrl}/${objectId}/groups/${groupId} resp = ${resp.status}`);
                if (resp.status == HttpStatusCode.Ok || resp.status == HttpStatusCode.NoContent) {
                    const obj = this.items.find(o => o.id === objectId);
                    if (obj && obj.groups) {
                        obj.groups = obj.groups.filter(g => g.id !== groupId);
                    }
                    return true;
                } else {
                    return false;
                }
            } catch (err) {
                const { notify } = useNotification();
                notify({
                    title: 'Удаление подъезда',
                    text: err.response?.data?.reason || err.message || 'Неизвестная ошибка',
                    type: 'error'
                });
                console.error(`objectStore.deleteGroup ${err}`);
                return false;
            } finally {
                loader.hide();
            }
        }
    },
    // getters:{
    //     async objects(state) {
    //         console.log('objects.access, ',state.items.length);
    //         if (!state.items.length) {
    //             await this.fetchAll();
    //         }
    //         return state.items;
    //     }, 
        // groupById: (state)=>async (groupId)=> {
        //     const obj = await this.objectByGroupId(groupId);
        //     console.log('object=',obj)
        //     return obj.groups.find(g=>g.id===groupId);
        // },
        // objectByGroupId: (state)=>async (groupid)=> {
        //     const obj = await this.objects;
        //     return obj.find(o=>{
        //         return o.groups.find(g=>g.id === groupId);
        //     });
        // },

    // }
});    
